export function GroupSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/group.svg'"></ng-include>`
    }
}